import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setCatalogRemoveCapacity, setCatalogRemoveDriveTrain, setCatalogRemoveEqClassCode, setCatalogRemoveNoOfDoor, setCatalogRemovePowerType, setCatalogRemoveUpfit, setCatalogRemoveVehicleLevel, setCatalogRemoveYear, setCatalogRemoveMake, setCatalogUpdateCapacity, setCatalogUpdateCapacitySave, setCatalogUpdateCapacityValidate, setCatalogUpdateDriveTrain, setCatalogUpdateDriveTrainSave, setCatalogUpdateDriveTrainValidate, setCatalogUpdateEqClassCode, setCatalogUpdateEqClassCodeSave, setCatalogUpdateEqClassCodeValidate, setCatalogUpdateNoOfDoorSave, setCatalogUpdateNoOfDoorValidate, setCatalogUpdateNoOfDoors, setCatalogUpdatePowerType, setCatalogUpdatePowerTypeSave, setCatalogUpdatePowerTypeValidate, setCatalogUpdateUpfit, setCatalogUpdateUpfitSave, setCatalogUpdateUpfitValidate, setCatalogUpdateVehicleLevel, setCatalogUpdateVehicleLevelSave, setCatalogUpdateVehicleLevelValidate, setCatalogUpdateYear, setCatalogUpdateYearSave, setCatalogUpdateYearValidate, setCatalogUpdateMake, setCatalogUpdateMakeSave, setCatalogUpdateMakeValidate, setCatalogUpdateModelSave, setCatalogUpdateModelValidate, setBudgetingPercentList, isBudgetingPercentOptionValid, isBudgetingPercentOptionDeleted, isBudgetingPercentOptionSaved, isUsefulLifeOptionSaved, isUsefulLifeOptionValid, setUsefulLifeList, isUsefulLifeOptionDeleted, setCatalogUpdateModel, setCatalogRemoveModel, setCatalogUpdateStateAvailability, setCatalogUpdateStateAvailabilitySave, setCatalogUpdateStateAvailabilityValidate, setCatalogRemoveStateAvailability, setCatalogUpdateProgramStatus, setCatalogUpdateProgramStatusSave, setCatalogUpdateProgramStatusValidate, setCatalogRemoveProgramStatus, setCatalogUpdateAnnualHours, setCatalogUpdateAnnualHoursSave, setCatalogUpdateAnnualHoursValidate, setCatalogRemoveAnnualHours, setCatalogUpdateDeckSize, setCatalogUpdateDeckSizeSave, setCatalogUpdateDeckSizeValidate, setCatalogRemoveDeckSize, setCatalogRemoveDeckType, setCatalogUpdateDeckTypeValidate, setCatalogUpdateDeckTypeSave, setCatalogUpdateDeckType, setCatalogRemoveSize, setCatalogUpdateSizeValidate, setCatalogUpdateSizeSave, setCatalogUpdateSize, setCatalogUpdateLengthValidate, setCatalogRemoveLength, setCatalogUpdateLengthSave, setCatalogUpdateLength, setCatalogUpdateAutonomous, setCatalogUpdateAutonomousSave, setCatalogUpdateAutonomousValidate, setCatalogRemoveAutonomous, setCatalogUpdateCategory, setCatalogUpdateCategorySave, setCatalogUpdateCategoryValidate, setCatalogRemoveCategory, setCatalogUpdateCategoryType, setCatalogUpdateCategoryTypeSave, setCatalogUpdateCategoryTypeValidate, setCatalogRemoveCategoryType, setCatalogUpdateCategory2, setCatalogUpdateCategory2Save, setCatalogUpdateCategory2Validate, setCatalogRemoveCategory2, setCatalogUpdateType, setCatalogUpdateTypeSave, setCatalogUpdateTypeValidate, setCatalogRemoveType, isTagsOptionValid, setTagsList, isTagsOptionDeleted, isTagsOptionSaved, setEditCatalogVehicleCapacity, setCatalogRemoveVehicleClass, setCatalogUpdateVehicleClassValidate, setCatalogUpdateVehicleClassSave, setCatalogUpdateVehicleClass, setCatalogUpdateGroupType, setCatalogUpdateGroupTypeSave, setCatalogUpdateGroupTypeValidate, setCatalogRemoveGroupType, setCatalogUpdateClassType, setCatalogUpdateClassTypeSave, setCatalogUpdateClassTypeValidate, setCatalogRemoveClassType, setCatalogUpdateGrossWeight, setCatalogUpdateGrossWeightSave, setCatalogUpdateGrossWeightValidate, setCatalogRemoveGrossWeight, setCatalogUpdateTrim, setCatalogUpdateTrimSave, setCatalogUpdateTrimValidate, setCatalogRemoveTrim } from 'Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction';
import { DELETE_BUDGETING_PERCENT_OPTION, DELETE_TAGS_OPTION, DELETE_USEFUL_LIFE_OPTION, GET_BUDGETING_PERCENT_LIST, GET_CATALOG_REMOVE_ANNUAL_HOURS, GET_CATALOG_REMOVE_AUTONOMOUS, GET_CATALOG_REMOVE_CAPACITY, GET_CATALOG_REMOVE_CATEGORY, GET_CATALOG_REMOVE_CATEGORY2, GET_CATALOG_REMOVE_CATEGORY_TYPE, GET_CATALOG_REMOVE_CLASS_TYPE, GET_CATALOG_REMOVE_DECK_SIZE, GET_CATALOG_REMOVE_DECK_TYPE, GET_CATALOG_REMOVE_DRIVE_TRAIN, GET_CATALOG_REMOVE_EQ_CLASS_CODE, GET_CATALOG_REMOVE_GROSS_WEIGHT, GET_CATALOG_REMOVE_GROUP_TYPE, GET_CATALOG_REMOVE_LENGTH, GET_CATALOG_REMOVE_MAKE, GET_CATALOG_REMOVE_MODEL, GET_CATALOG_REMOVE_NO_OF_DOORS, GET_CATALOG_REMOVE_POWER_TYPE, GET_CATALOG_REMOVE_PROGRAM_STATUS, GET_CATALOG_REMOVE_SIZE, GET_CATALOG_REMOVE_STATE_AVAILABILITY, GET_CATALOG_REMOVE_TRIM, GET_CATALOG_REMOVE_TYPE, GET_CATALOG_REMOVE_UPFIT, GET_CATALOG_REMOVE_VEHICLE_CLASS, GET_CATALOG_REMOVE_VEHICLE_LEVEL, GET_CATALOG_REMOVE_YEAR, GET_CATALOG_UPDATE_ANNUAL_HOURS, GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE, GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE, GET_CATALOG_UPDATE_AUTONOMOUS, GET_CATALOG_UPDATE_AUTONOMOUS_SAVE, GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE, GET_CATALOG_UPDATE_CAPACITY, GET_CATALOG_UPDATE_CAPACITY_SAVE, GET_CATALOG_UPDATE_CAPACITY_VALIDATE, GET_CATALOG_UPDATE_CATEGORY, GET_CATALOG_UPDATE_CATEGORY2, GET_CATALOG_UPDATE_CATEGORY2_SAVE, GET_CATALOG_UPDATE_CATEGORY2_VALIDATE, GET_CATALOG_UPDATE_CATEGORY_SAVE, GET_CATALOG_UPDATE_CATEGORY_TYPE, GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE, GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE, GET_CATALOG_UPDATE_CATEGORY_VALIDATE, GET_CATALOG_UPDATE_CLASS_TYPE, GET_CATALOG_UPDATE_CLASS_TYPE_SAVE, GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE, GET_CATALOG_UPDATE_DECK_SIZE, GET_CATALOG_UPDATE_DECK_SIZE_SAVE, GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE, GET_CATALOG_UPDATE_DECK_TYPE, GET_CATALOG_UPDATE_DECK_TYPE_SAVE, GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE, GET_CATALOG_UPDATE_DRIVE_TRAIN, GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE, GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE, GET_CATALOG_UPDATE_EQ_CLASS_CODE, GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE, GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE, GET_CATALOG_UPDATE_GROSS_WEIGHT, GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE, GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE, GET_CATALOG_UPDATE_GROUP_TYPE, GET_CATALOG_UPDATE_GROUP_TYPE_SAVE, GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE, GET_CATALOG_UPDATE_LENGTH, GET_CATALOG_UPDATE_LENGTH_SAVE, GET_CATALOG_UPDATE_LENGTH_VALIDATE, GET_CATALOG_UPDATE_MAKE, GET_CATALOG_UPDATE_MAKE_SAVE, GET_CATALOG_UPDATE_MAKE_VALIDATE, GET_CATALOG_UPDATE_MODEL, GET_CATALOG_UPDATE_MODEL_SAVE, GET_CATALOG_UPDATE_MODEL_VALIDATE, GET_CATALOG_UPDATE_NO_OF_DOORS, GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE, GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE, GET_CATALOG_UPDATE_POWER_TYPE, GET_CATALOG_UPDATE_POWER_TYPE_SAVE, GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE, GET_CATALOG_UPDATE_PROGRAM_STATUS, GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE, GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE, GET_CATALOG_UPDATE_SIZE, GET_CATALOG_UPDATE_SIZE_SAVE, GET_CATALOG_UPDATE_SIZE_VALIDATE, GET_CATALOG_UPDATE_STATE_AVAILABILITY, GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE, GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE, GET_CATALOG_UPDATE_TRIM, GET_CATALOG_UPDATE_TRIM_SAVE, GET_CATALOG_UPDATE_TRIM_VALIDATE, GET_CATALOG_UPDATE_TYPE, GET_CATALOG_UPDATE_TYPE_SAVE, GET_CATALOG_UPDATE_TYPE_VALIDATE, GET_CATALOG_UPDATE_UPFIT, GET_CATALOG_UPDATE_UPFIT_SAVE, GET_CATALOG_UPDATE_UPFIT_VALIDATE, GET_CATALOG_UPDATE_VEHICLE_CLASS, GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE, GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE, GET_CATALOG_UPDATE_VEHICLE_LEVEL, GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE, GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE, GET_CATALOG_UPDATE_YEAR, GET_CATALOG_UPDATE_YEAR_SAVE, GET_CATALOG_UPDATE_YEAR_VALIDATE, GET_EDIT_CATALOG_VEHICLE_CAPACITY, GET_TAGS_LIST, GET_USEFUL_LIFE_LIST, SAVE_BUDGETING_PERCENT_OPTION, SAVE_TAGS_OPTION, SAVE_USEFUL_LIFE_OPTION, VALIDATE_BUDGETING_PERCENT_OPTION, VALIDATE_TAGS_OPTION, VALIDATE_USEFUL_LIFE_OPTION } from 'Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateType';

function* getCatalogUpdateNoOfDoorsSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateNoOfDoors(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateNoOfDoors([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateNoOfDoorSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateNoOfDoorSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateNoOfDoorSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateNoOfDoorValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateNoOfDoorValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateNoOfDoorValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveNoOfDoorsSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveNoOfDoor(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveNoOfDoor(false))
        yield put(globalLoaderText(""));
    }
}

///Year

function* getCatalogUpdateYearSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateYear(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateYear([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateYearSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateYearSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateYearSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateYearValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateYearValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateYearValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveYearSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveYear(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveYear(false))
        yield put(globalLoaderText(""));
    }
}

///Capacity
function* getCatalogUpdateCapacitySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCapacity(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCapacity([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCapacitySaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCapacitySave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCapacitySave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCapacityValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCapacityValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCapacityValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveCapacitySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveCapacity(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveCapacity(false))
        yield put(globalLoaderText(""));
    }
}

///Upfit
function* getCatalogUpdateUpfitSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateUpfit(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateUpfit([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateUpfitSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateUpfitSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateUpfitSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateUpfitValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateUpfitValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateUpfitValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveUpfitSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveUpfit(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveUpfit(false))
        yield put(globalLoaderText(""));
    }
}

///DriveTrain
function* getCatalogUpdateDriveTrainSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDriveTrain(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDriveTrain([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDriveTrainSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDriveTrainSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDriveTrainSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDriveTrainValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDriveTrainValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDriveTrainValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveDriveTrainSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveDriveTrain(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveDriveTrain(false))
        yield put(globalLoaderText(""));
    }
}

///Power type
function* getCatalogUpdatePowerTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdatePowerType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdatePowerType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdatePowerTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdatePowerTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdatePowerTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdatePowerTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdatePowerTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdatePowerTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemovePowerTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemovePowerType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemovePowerType(false))
        yield put(globalLoaderText(""));
    }
}

///Vehicle Level
function* getCatalogUpdateVehicleLevelSaga(): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/vehiclelevel`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleLevel(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleLevel([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateVehicleLevelSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/vehiclelevel`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleLevelSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleLevelSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateVehicleLevelValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/vehiclelevel/validate?vehicleLevelValue=${req.payload.vehiclelevel}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleLevelValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleLevelValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveVehicleLevelSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/vehiclelevel/delete`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveVehicleLevel(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveVehicleLevel(false))
        yield put(globalLoaderText(""));
    }
}

///EQ Class Code
function* getCatalogUpdateEqClassCodeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/eqclasscode/${req?.subTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateEqClassCode(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateEqClassCode([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateEqClassCodeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/eqclasscode`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateEqClassCodeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateEqClassCodeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateEqClassCodeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/eqclasscode/validate/${req.payload.subTypeId}?eqClassCodeValue=${req.payload.eqclasscode}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateEqClassCodeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateEqClassCodeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveEqClassCodeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/eqclasscode/delete`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveEqClassCode(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveEqClassCode(false))
        yield put(globalLoaderText(""));
    }
}

///Make
function* getCatalogUpdateMakeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.isEquipment}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateMake(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateMake([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateMakeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateMakeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateMakeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateMakeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateMakeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateMakeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveMakeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveMake(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveMake(false))
        yield put(globalLoaderText(""));
    }
}

///State availability
function* getCatalogUpdateStateAvailabilitySaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateStateAvailability(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateStateAvailability([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateStateAvailabilitySaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateStateAvailabilitySave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateStateAvailabilitySave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateStateAvailabilityValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateStateAvailabilityValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateStateAvailabilityValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveStateAvailabilitySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveStateAvailability(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveStateAvailability(false))
        yield put(globalLoaderText(""));
    }
}

///Model

function* getCatalogUpdateModelSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/dropdown/${req?.subTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateModel(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateModel([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveModelSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveModel(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveModel(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateModelSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateModelSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateModelSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateModelValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/validate`,
        payload: req.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateModelValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateModelValidate(false))
        yield put(globalLoaderText(""));
    }
}


///Budgeting Percent
function* getBudgetingPercentOptions(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.payload}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setBudgetingPercentList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setBudgetingPercentList([]))
        yield put(globalLoaderText(""));
    }
}

function* validateBudgetingPercentOption(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isBudgetingPercentOptionValid(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isBudgetingPercentOptionValid(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveBudgetingPercentSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isBudgetingPercentOptionDeleted(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isBudgetingPercentOptionDeleted(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateBudgetingPercentSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isBudgetingPercentOptionSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isBudgetingPercentOptionSaved(false))
        yield put(globalLoaderText(""));
    }
}

///Use Life/Lease terms
function* getUsefullifeTermsOptions(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.payload}?attributeName=${req.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setUsefulLifeList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUsefulLifeList([]))
        yield put(globalLoaderText(""));
    }
}

function* validateUsefullifeTermsOption(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isUsefulLifeOptionValid(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isUsefulLifeOptionValid(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveUsefullifeTermsSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isUsefulLifeOptionDeleted(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isUsefulLifeOptionDeleted(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateUsefullifeTermsSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isUsefulLifeOptionSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isUsefulLifeOptionSaved(false))
        yield put(globalLoaderText(""));
    }
}

///Program status
function* getCatalogUpdateProgramStatusSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateProgramStatus(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateProgramStatus([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateProgramStatusSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateProgramStatusSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateProgramStatusSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateProgramStatusValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateProgramStatusValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateProgramStatusValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveProgramStatusSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveProgramStatus(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveProgramStatus(false))
        yield put(globalLoaderText(""));
    }
}

///Annual Hour
function* getCatalogUpdateAnnualHoursSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAnnualHours(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAnnualHours([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateAnnualHoursSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAnnualHoursSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAnnualHoursSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateAnnualHoursValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAnnualHoursValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAnnualHoursValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveAnnualHoursSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveAnnualHours(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveAnnualHours(false))
        yield put(globalLoaderText(""));
    }
}

///Deck Size

function* getCatalogUpdateDeckSizeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckSize(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckSize([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDeckSizeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckSizeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckSizeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDeckSizeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckSizeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckSizeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveDeckSizeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveDeckSize(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveDeckSize(false))
        yield put(globalLoaderText(""));
    }
}

///Deck Type

function* getCatalogUpdateDeckTypeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDeckTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateDeckTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateDeckTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateDeckTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveDeckTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveDeckType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveDeckType(false))
        yield put(globalLoaderText(""));
    }
}

///Size

function* getCatalogUpdateSizeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateSize(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateSize([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateSizeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateSizeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateSizeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateSizeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateSizeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateSizeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveSizeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveSize(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveSize(false))
        yield put(globalLoaderText(""));
    }
}

///Length

function* getCatalogUpdateLengthSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateLength(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateLength([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateLengthSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateLengthSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateLengthSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateLengthValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateLengthValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateLengthValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveLengthSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveLength(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveLength(false))
        yield put(globalLoaderText(""));
    }
}

///Autonomous

function* getCatalogUpdateAutonomousSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAutonomous(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAutonomous([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateAutonomousSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAutonomousSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAutonomousSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateAutonomousValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateAutonomousValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateAutonomousValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveAutonomousSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveAutonomous(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveAutonomous(false))
        yield put(globalLoaderText(""));
    }
}

///Category

function* getCatalogUpdateCategorySaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategory(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategory([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategorySaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategorySave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategorySave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategoryValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategoryValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategoryValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveCategorySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveCategory(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveCategory(false))
        yield put(globalLoaderText(""));
    }
}

///CategoryType

function* getCatalogUpdateCategoryTypeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategoryType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategoryType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategoryTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategoryTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategoryTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategoryTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/validate/${req.payload.subTypeId}?parentValue=${req.payload.attributeValue}&attributeName=${req?.payload?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategoryTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategoryTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveCategoryTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveCategoryType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveCategoryType(false))
        yield put(globalLoaderText(""));
    }
}

///Category2

function* getCatalogUpdateCategory2Saga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategory2(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategory2([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategory2SaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategory2Save(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategory2Save(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateCategory2ValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/childattribute/validate/${req.payload.subTypeId}?parentValue=${req.payload.attributeValue}&attributeName=${req?.payload?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateCategory2Validate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateCategory2Validate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveCategory2Saga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveCategory2(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveCategory2(false))
        yield put(globalLoaderText(""));
    }
}

///Type

function* getCatalogUpdateTypeSaga(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveType(false))
        yield put(globalLoaderText(""));
    }
}

//Tags
function* getTagsOptions(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.payload}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setTagsList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setTagsList([]))
        yield put(globalLoaderText(""));
    }
}

function* validateTagsOption(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isTagsOptionValid(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isTagsOptionValid(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveTagsSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isTagsOptionDeleted(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isTagsOptionDeleted(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateTagsSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(isTagsOptionSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(isTagsOptionSaved(false))
        yield put(globalLoaderText(""));
    }
}

///Capacity
function* getEditCatalogUpdateCapacitySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.PUT,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.val
    }
    try {
        yield put(globalLoaderText("Editing values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setEditCatalogVehicleCapacity(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setEditCatalogVehicleCapacity(false))
        yield put(globalLoaderText(""));
    }
}

///Vehicle Class

function* getCatalogUpdateVehicleClassSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleClass(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleClass([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateVehicleClassSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleClassSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleClassSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateVehicleClassValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateVehicleClassValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateVehicleClassValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveVehicleClassSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveVehicleClass(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveVehicleClass(false))
        yield put(globalLoaderText(""));
    }
}

///Group Type

function* getCatalogUpdateGroupTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGroupType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGroupType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateGroupTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGroupTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGroupTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateGroupTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGroupTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGroupTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveGroupTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveGroupType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveGroupType(false))
        yield put(globalLoaderText(""));
    }
}

///Class Type

function* getCatalogUpdateClassTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateClassType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateClassType([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateClassTypeSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateClassTypeSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateClassTypeSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateClassTypeValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateClassTypeValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateClassTypeValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveClassTypeSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveClassType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveClassType(false))
        yield put(globalLoaderText(""));
    }
}

///Gross Weight

function* getCatalogUpdateGrossWeightSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGrossWeight(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGrossWeight([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateGrossWeightSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGrossWeightSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGrossWeightSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateGrossWeightValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateGrossWeightValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateGrossWeightValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveGrossWeightSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveGrossWeight(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveGrossWeight(false))
        yield put(globalLoaderText(""));
    }
}

///Trim
function* getCatalogUpdateTrimSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/${req?.subTypeId}?attributeName=${req?.attributeName}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching values...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateTrim(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateTrim([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateTrimSaveSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateTrimSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateTrimSave(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogUpdateTrimValidateSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogUpdateTrimValidate(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogUpdateTrimValidate(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogRemoveTrimSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.DELETE,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Deleting value...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogRemoveTrim(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogRemoveTrim(false))
        yield put(globalLoaderText(""));
    }
}


function* watchGetCondition() {
    yield takeEvery(GET_CATALOG_UPDATE_NO_OF_DOORS, getCatalogUpdateNoOfDoorsSaga)
    yield takeEvery(GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE, getCatalogUpdateNoOfDoorSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE, getCatalogUpdateNoOfDoorValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_NO_OF_DOORS, getCatalogRemoveNoOfDoorsSaga)

    yield takeEvery(GET_CATALOG_UPDATE_YEAR, getCatalogUpdateYearSaga)
    yield takeEvery(GET_CATALOG_UPDATE_YEAR_SAVE, getCatalogUpdateYearSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_YEAR_VALIDATE, getCatalogUpdateYearValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_YEAR, getCatalogRemoveYearSaga)

    yield takeEvery(GET_CATALOG_UPDATE_CAPACITY, getCatalogUpdateCapacitySaga)
    yield takeEvery(GET_CATALOG_UPDATE_CAPACITY_SAVE, getCatalogUpdateCapacitySaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CAPACITY_VALIDATE, getCatalogUpdateCapacityValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_CAPACITY, getCatalogRemoveCapacitySaga)
    yield takeEvery(GET_EDIT_CATALOG_VEHICLE_CAPACITY, getEditCatalogUpdateCapacitySaga)

    yield takeEvery(GET_CATALOG_UPDATE_UPFIT, getCatalogUpdateUpfitSaga)
    yield takeEvery(GET_CATALOG_UPDATE_UPFIT_SAVE, getCatalogUpdateUpfitSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_UPFIT_VALIDATE, getCatalogUpdateUpfitValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_UPFIT, getCatalogRemoveUpfitSaga)

    yield takeEvery(GET_CATALOG_UPDATE_DRIVE_TRAIN, getCatalogUpdateDriveTrainSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE, getCatalogUpdateDriveTrainSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE, getCatalogUpdateDriveTrainValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_DRIVE_TRAIN, getCatalogRemoveDriveTrainSaga)

    yield takeEvery(GET_CATALOG_UPDATE_POWER_TYPE, getCatalogUpdatePowerTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_POWER_TYPE_SAVE, getCatalogUpdatePowerTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE, getCatalogUpdatePowerTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_POWER_TYPE, getCatalogRemovePowerTypeSaga)
    
    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_LEVEL, getCatalogUpdateVehicleLevelSaga)
    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE, getCatalogUpdateVehicleLevelSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE, getCatalogUpdateVehicleLevelValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_VEHICLE_LEVEL, getCatalogRemoveVehicleLevelSaga)

    yield takeEvery(GET_CATALOG_UPDATE_EQ_CLASS_CODE, getCatalogUpdateEqClassCodeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE, getCatalogUpdateEqClassCodeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE, getCatalogUpdateEqClassCodeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_EQ_CLASS_CODE, getCatalogRemoveEqClassCodeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_MAKE, getCatalogUpdateMakeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_MAKE_SAVE, getCatalogUpdateMakeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_MAKE_VALIDATE, getCatalogUpdateMakeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_MAKE, getCatalogRemoveMakeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_STATE_AVAILABILITY, getCatalogUpdateStateAvailabilitySaga)
    yield takeEvery(GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE, getCatalogUpdateStateAvailabilitySaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE, getCatalogUpdateStateAvailabilityValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_STATE_AVAILABILITY, getCatalogRemoveStateAvailabilitySaga)

    yield takeEvery(GET_CATALOG_UPDATE_MODEL_SAVE, getCatalogUpdateModelSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_MODEL_VALIDATE, getCatalogUpdateModelValidateSaga)
    yield takeEvery(GET_CATALOG_UPDATE_MODEL, getCatalogUpdateModelSaga)
    yield takeEvery(GET_CATALOG_REMOVE_MODEL, getCatalogRemoveModelSaga)

    yield takeEvery(GET_BUDGETING_PERCENT_LIST, getBudgetingPercentOptions)
    yield takeEvery(VALIDATE_BUDGETING_PERCENT_OPTION, validateBudgetingPercentOption)
    yield takeEvery(DELETE_BUDGETING_PERCENT_OPTION, getCatalogRemoveBudgetingPercentSaga)
    yield takeEvery(SAVE_BUDGETING_PERCENT_OPTION, getCatalogUpdateBudgetingPercentSaveSaga)

    yield takeEvery(GET_USEFUL_LIFE_LIST, getUsefullifeTermsOptions)
    yield takeEvery(VALIDATE_USEFUL_LIFE_OPTION, validateUsefullifeTermsOption)
    yield takeEvery(DELETE_USEFUL_LIFE_OPTION, getCatalogRemoveUsefullifeTermsSaga)
    yield takeEvery(SAVE_USEFUL_LIFE_OPTION, getCatalogUpdateUsefullifeTermsSaveSaga)

    yield takeEvery(GET_CATALOG_UPDATE_PROGRAM_STATUS, getCatalogUpdateProgramStatusSaga)
    yield takeEvery(GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE, getCatalogUpdateProgramStatusSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE, getCatalogUpdateProgramStatusValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_PROGRAM_STATUS, getCatalogRemoveProgramStatusSaga)

    yield takeEvery(GET_CATALOG_UPDATE_ANNUAL_HOURS, getCatalogUpdateAnnualHoursSaga)
    yield takeEvery(GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE, getCatalogUpdateAnnualHoursSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE, getCatalogUpdateAnnualHoursValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_ANNUAL_HOURS, getCatalogRemoveAnnualHoursSaga)

    yield takeEvery(GET_CATALOG_UPDATE_DECK_SIZE, getCatalogUpdateDeckSizeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DECK_SIZE_SAVE, getCatalogUpdateDeckSizeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE, getCatalogUpdateDeckSizeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_DECK_SIZE, getCatalogRemoveDeckSizeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_DECK_TYPE, getCatalogUpdateDeckTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DECK_TYPE_SAVE, getCatalogUpdateDeckTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE, getCatalogUpdateDeckTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_DECK_TYPE, getCatalogRemoveDeckTypeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_SIZE, getCatalogUpdateSizeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_SIZE_SAVE, getCatalogUpdateSizeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_SIZE_VALIDATE, getCatalogUpdateSizeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_SIZE, getCatalogRemoveSizeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_LENGTH, getCatalogUpdateLengthSaga)
    yield takeEvery(GET_CATALOG_UPDATE_LENGTH_SAVE, getCatalogUpdateLengthSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_LENGTH_VALIDATE, getCatalogUpdateLengthValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_LENGTH, getCatalogRemoveLengthSaga)

    yield takeEvery(GET_CATALOG_UPDATE_AUTONOMOUS, getCatalogUpdateAutonomousSaga)
    yield takeEvery(GET_CATALOG_UPDATE_AUTONOMOUS_SAVE, getCatalogUpdateAutonomousSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE, getCatalogUpdateAutonomousValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_AUTONOMOUS, getCatalogRemoveAutonomousSaga)

    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY, getCatalogUpdateCategorySaga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY_SAVE, getCatalogUpdateCategorySaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY_VALIDATE, getCatalogUpdateCategoryValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_CATEGORY, getCatalogRemoveCategorySaga)

    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY_TYPE, getCatalogUpdateCategoryTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE, getCatalogUpdateCategoryTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE, getCatalogUpdateCategoryTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_CATEGORY_TYPE, getCatalogRemoveCategoryTypeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY2, getCatalogUpdateCategory2Saga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY2_SAVE, getCatalogUpdateCategory2SaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CATEGORY2_VALIDATE, getCatalogUpdateCategory2ValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_CATEGORY2, getCatalogRemoveCategory2Saga)

    yield takeEvery(GET_CATALOG_UPDATE_TYPE, getCatalogUpdateTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_TYPE_SAVE, getCatalogUpdateTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_TYPE_VALIDATE, getCatalogUpdateTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_TYPE, getCatalogRemoveTypeSaga)

    yield takeEvery(GET_TAGS_LIST, getTagsOptions)
    yield takeEvery(VALIDATE_TAGS_OPTION, validateTagsOption)
    yield takeEvery(DELETE_TAGS_OPTION, getCatalogRemoveTagsSaga)
    yield takeEvery(SAVE_TAGS_OPTION, getCatalogUpdateTagsSaveSaga)

    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_CLASS, getCatalogUpdateVehicleClassSaga)
    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE, getCatalogUpdateVehicleClassSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE, getCatalogUpdateVehicleClassValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_VEHICLE_CLASS, getCatalogRemoveVehicleClassSaga)

    yield takeEvery(GET_CATALOG_UPDATE_GROUP_TYPE, getCatalogUpdateGroupTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_GROUP_TYPE_SAVE, getCatalogUpdateGroupTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE, getCatalogUpdateGroupTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_GROUP_TYPE, getCatalogRemoveGroupTypeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_CLASS_TYPE, getCatalogUpdateClassTypeSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CLASS_TYPE_SAVE, getCatalogUpdateClassTypeSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE, getCatalogUpdateClassTypeValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_CLASS_TYPE, getCatalogRemoveClassTypeSaga)

    yield takeEvery(GET_CATALOG_UPDATE_GROSS_WEIGHT, getCatalogUpdateGrossWeightSaga)
    yield takeEvery(GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE, getCatalogUpdateGrossWeightSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE, getCatalogUpdateGrossWeightValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_GROSS_WEIGHT, getCatalogRemoveGrossWeightSaga)

    yield takeEvery(GET_CATALOG_UPDATE_TRIM, getCatalogUpdateTrimSaga)
    yield takeEvery(GET_CATALOG_UPDATE_TRIM_SAVE, getCatalogUpdateTrimSaveSaga)
    yield takeEvery(GET_CATALOG_UPDATE_TRIM_VALIDATE, getCatalogUpdateTrimValidateSaga)
    yield takeEvery(GET_CATALOG_REMOVE_TRIM, getCatalogRemoveTrimSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetCondition()
    ])
}
